// extracted by mini-css-extract-plugin
export default {"form":"search_form__tQG-F","container":"search_container__4cllS","action":"search_action__7tYXn","collapse":"search_collapse__fZt-J","btnContainer":"search_btnContainer__fkLWk"};